var __jsx = React.createElement;
import React, { useState } from 'react';
import { useLang } from '@/common/Contexts/LanguageContext';
import { useTranslation } from "@i18n";
import Select from "@/components/UiKit/Select/Select";
import ContactSupportModal from "./ContactSupportModal";
import useIsMobile from "@hooks/useIsMobile";
var FinalCTASection = function FinalCTASection(_ref) {
  var selectedMake = _ref.selectedMake,
    onMakeChange = _ref.onMakeChange,
    onStartProcess = _ref.onStartProcess,
    carMakes = _ref.carMakes,
    title = _ref.title,
    subtitle = _ref.subtitle,
    ctaLabel = _ref.ctaLabel;
  var lang = useLang();
  var isMobile = useIsMobile();
  var isArabic = lang === 'ar';
  var _useTranslation = useTranslation(["web_sell_trade"]),
    tShort = _useTranslation.tShort;
  var _useState = useState(false),
    isContactPopupOpen = _useState[0],
    setIsContactPopupOpen = _useState[1];
  var handleContactUsClick = function handleContactUsClick(e) {
    e.preventDefault();
    setIsContactPopupOpen(true);
  };
  var handleCloseContactPopup = function handleCloseContactPopup() {
    setIsContactPopupOpen(false);
  };
  return /*#__PURE__*/React.createElement("section", {
    id: "final-cta-section",
    className: "mt-20 mb-5 md:mt-[71px] px-4"
  }, /*#__PURE__*/React.createElement("div", {
    id: "final-cta-container",
    className: "max-w-full mx-auto  border-solid border-[#F1F6FC] border-[2px] shadow-sm rounded-[16px] pt-10 pb-12 px-2 text-center md:max-w-[1200px] md:py-15 md:px-5"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "final-cta-title",
    className: "text-[36px] font-bold text-primary-new mb-4 md:text-[28px] md:mb-3 sm:text-[24px]"
  }, title), /*#__PURE__*/React.createElement("p", {
    id: "final-cta-subtitle",
    className: "text-[20px] font-medium text-[#666] mb-8 md:text-[18px] md:mb-6 py-4"
  }, subtitle), /*#__PURE__*/React.createElement("div", {
    id: "final-cta-form-container",
    className: "space-y-5 w-full mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    id: "final-cta-make-dropdown-container",
    className: "flex-1  flex flex-col items-start rtl:text-end text-start"
  }, /*#__PURE__*/React.createElement("label", {
    id: "final-cta-make-label",
    className: "text-[16px] font-semibold text-[#555] mb-2"
  }, tShort('final_cta/make_label', {
    ns: 'web_sell_trade'
  })), /*#__PURE__*/React.createElement(Select, {
    id: "final-cta-make-dropdown",
    name: "make",
    type: "select",
    className: "w-full h-12 border border-[#ddd] rounded-[6px] text-[16px] bg-white text-[#333] transition-colors duration-300 focus:border-primary-new focus:outline-none disabled:bg-[#f5f5f5] disabled:cursor-not-allowed",
    value: selectedMake,
    onChange: function onChange(event) {
      return onMakeChange(event.currentTarget.value);
    },
    renderEmptyOption: false
  }, /*#__PURE__*/React.createElement("option", {
    id: "final-cta-make-placeholder",
    value: "",
    disabled: true,
    hidden: true
  }, tShort('final_cta/make_placeholder', {
    ns: 'web_sell_trade'
  })), carMakes.map(function (make) {
    return /*#__PURE__*/React.createElement("option", {
      id: "final-cta-make-option-".concat(make.id),
      key: make.id,
      value: make.id.toString()
    }, make.name);
  }))), /*#__PURE__*/React.createElement("button", {
    id: "final-cta-submit-button",
    className: "w-full h-[52px] bg-primary-new text-white text-[18px] font-bold border-none rounded-[6px] cursor-pointer transition-all duration-300 ease-in-out mt-5 hover:bg-[#3c56d4] hover:translate-y-[-2px] hover:shadow-[0_6px_12px_rgba(0,0,0,0.1)] md:w-[206px]",
    onClick: onStartProcess,
    "aria-label": tShort('final_cta/submit_button', {
      ns: 'web_sell_trade'
    })
  }, ctaLabel)), /*#__PURE__*/React.createElement("p", {
    id: "final-cta-help-text",
    className: "text-[16px] text-primary-new mt-9"
  }, tShort('final_cta/need_help', {
    ns: 'web_sell_trade'
  }), " ", /*#__PURE__*/React.createElement("a", {
    id: "final-cta-contact-us-link",
    href: "#contact-us",
    className: "px-1 text-primary-new  transition-colors duration-300 hover:text-primary-new underline",
    onClick: handleContactUsClick
  }, tShort('final_cta/contact_us', {
    ns: 'web_sell_trade'
  })))), /*#__PURE__*/React.createElement(ContactSupportModal, {
    isOpen: isContactPopupOpen,
    onClose: handleCloseContactPopup
  }));
};
export default FinalCTASection;